var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white !important"}},[_c('v-container',{staticClass:"pa-12",staticStyle:{"max-width":"1300px !important"}},[_c('edit-article-component',{attrs:{"id":_vm.$route.params.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }